module.exports = __webpack_public_path__ + "static/ha-couple-zoom-5366e9a825e393d3fc9ab045106653ad.jpg";